import React, { useState } from 'react';
import {
	Message,
	MessageAttachment,
	useLazyConversationMessagesQuery,
	User,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
// @ts-ignore
import styles from './ActionCenterConversationMessageList.module.scss';
import { getMomentDate } from '../../../../Utils/dates.util';
import { useAppContext } from '../../../../Services/AppContext';
import Text from '../../../../Components/Base/Text/Text';
import ActionCenterConversationMessageAttachment from './ActionCenterConversationMessageAttachment';
import { useEffectAsync } from '../../../../helpers';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import NoEscape from '../../../../Components/NoEscape';
import { findAndReplaceLinksInText } from '../../../Base/Helpers/text.helper';
import ActionCenterMessageRecipients from '../ActionCenterMessageDetail/ActionCenterMessageRecipients';

interface Props {
	conversationId: string;
}

const ActionCenterConversationMessageList: React.FC<Props> = ({
	conversationId,
}) => {
	const [getMessage] = useLazyConversationMessagesQuery();
	const [isLoading, setIsLoading] = useState(false);
	const [messages, setMessages] = useState<Message[]>([]);

	const loadData = async () => {
		setIsLoading(true);
		const data = await getMessage({ conversationId }).unwrap();
		if (data?.messages?.data) {
			setMessages(data?.messages?.data as Message[]);
		}
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await loadData();
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div>
			{messages?.map((item, key) => {
				if (key === 0) {
					return;
				}
				return (
					<div className={styles.wrapper} key={key}>
						<div className={styles.date}>
							<FormattedMomentDate
								date={item?.createdAt}
								format={DateFormat.DATE_TIME}
							/>
						</div>
						<div className={styles.name}>
							<Text tx='base.shared.from' firstUpper inline />:{' '}
							{item?.sender?.user?.profile?.fullName}
						</div>
						<div className={styles.recipients}>
							<ActionCenterMessageRecipients
								conversationMembers={
									item?.messageRecipients?.map(
										recipient => recipient.user,
									) as User[]
								}
								sender={item.sender?.user}
							/>
						</div>

						<div className={styles.content}>
							<NoEscape>
								{findAndReplaceLinksInText(item?.content?.text)}
							</NoEscape>
						</div>
						{(item?.messageAttachments?.length || 0) > 0 && (
							<div className={styles.attachments}>
								<div className={styles.title}>
									<Text tx='base.attachments' inline firstUpper />:
								</div>
								{item?.messageAttachments?.map(attachment => (
									<ActionCenterConversationMessageAttachment
										key={attachment?.id}
										item={attachment as MessageAttachment}
									/>
								))}
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default ActionCenterConversationMessageList;
